/**
 * The full trimmed/lowercased address is the user identity. Plus segments are
 * intentionally opaque; district routing is handled separately by AE-211.
 */
export function normalizeEmailIdentity(email: string): string {
  return email.trim().toLowerCase();
}
